import { INPUT_FILE_FORMATS } from 'modules/merchantinfo/constants/constants';

export const KYC_TAB_TITLES = {
  RFI_SUMMARY: 'RFI Summary',
  REQUESTED_RFI: 'Requested RFIs',
  SUBMITTED_RFI: 'Submitted RFIs',
  IN_REVIEW_RFI: 'In Review',
  DELAYED_RFI: 'Delayed RFIs',
  INITIATED_ON_PARTNER: 'Initiated on Partner',
};
export const BY_ENTITY_ID = 'by Entity Id';

export const RFI_STATUS_TABLE_HEADERS = ['Date', 'Entity ID', 'Entity Name', 'RFI Status', 'Risk Level'];
export const RFI_SUMMARY_TABLE_HEADERS = ['RFI Summary', '<24 Hours', '24-48 Hours', '>48 Hours', '>7 Days'];

export const RFI_STATUS = {
  RFI_SUBMITTED: 'rfi_submitted',
  RFI_REQUESTED: 'rfi_requested',
  IN_REVIEW: 'in_review',
  RFI_DELAYED: 'rfi_delayed',
};

export const TAB_TYPE_MAP = {
  1: 'rfi_requested',
  2: 'rfi_submitted',
  3: 'in_review',
  4: 'delayed',
};

export const KYB_TAB_TITLES = {
  IN_REVIEW: 'In Review',
  ACTIVE_KYBS: 'Active KYBs',
};

export const KYB_RFI_TYPE = {
  IN_REVIEW: 'in_review',
  ACTIVE: 'active',
};

export const DEFAULT_PAGE_SIZE = 10;

export const EXPIRTY_DATE_REGEX = /^(0[1-9]|1[0-2])\/\d{4}$/;

export const DOCUMENT_ACCEPTED_FORMATS = [
  INPUT_FILE_FORMATS.PNG,
  INPUT_FILE_FORMATS.JPEG,
  INPUT_FILE_FORMATS.JPG,
  INPUT_FILE_FORMATS.PDF,
  INPUT_FILE_FORMATS.BMP,
];

export const FILE_EXTENSION_REGEX = /(image\/|video\/|\.)/;

export const EMAIL_TYPE_OPTIONS = [
  { label: 'Transaction RFI for Salaried/Self employed', value: 'transaction_rfi_salaried_self_employed' },
  { label: 'Transaction RFI Student/Unemployed/Retire', value: 'transaction_rfi_student_unemployed_retired' },
  { label: 'Transaction RFI for Expired IDs', value: 'transaction_rfi_expired_id' },
  { label: 'KYC RFI for Address confirmation', value: 'kyc_rfi_address' },
  { label: 'KYC RFI for Employer Details', value: 'kyc_rfi_employer_details' },
  { label: 'KYC RFI for EDD', value: 'kyc_rfi_edd' },
];

export const PARTNER_INITIATED_TAB_INDEX = 5;

export const PARTNER_INITIATED_TABLE_HEADERS = [
  'Created',
  'KYC ID',
  'Entity Name',
  'Risk Level',
  'KYC Status',
  'Partner Status',
  'Partner Account ID',
  'Pending Documents',
  '',
];

export const KYC_PARTNER_LABELS = {
  ONE_MONEY: '1Money',
};

export const DEFAULT_KYC_PARTNER_CODE = 'ONE_MONEY';

export const KYC_PARTNER_AUDIT_PARENT_KEY = 'one_money_partner_audit';

export const KYC_PARTNER_ACCOUNT_FIELDS = [
  { label: 'Status', key: 'status' },
  { label: 'Account ID', key: 'account_id' },
  { label: 'Parent Account ID', key: 'parent_account_id' },
  { label: 'External ID', key: 'external_id' },
  { label: 'Created At', key: 'created_at' },
  { label: 'Updated At', key: 'updated_at' },
  { label: 'Submitted At', key: 'submitted_at' },
];

export const KYC_PARTNER_ACCOUNT_STATUS = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const KYC_PARTNER_PENDING_SUBMISSION_STATUSES = [
  KYC_PARTNER_ACCOUNT_STATUS.DRAFT,
  KYC_PARTNER_ACCOUNT_STATUS.ACTION_REQUIRED,
];

export const KYC_PARTNER_DOCUMENT_TABLE_HEADERS = ['Type', 'Status', 'Required'];
